import React from 'react'
import { Card as NUICard, Text } from '@theneatcompany/nui'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './Card.module.scss'

const Card = props => <NUICard {...props} />

Card.Header = ({ messageId }) => (
  <div className={styles.header}>
    <Text element="h3" typeStyle="bold" type="display" size="small">
      <FormattedMessage id={messageId} />
    </Text>
  </div>
)

Card.Body = ({ children, className = '' }) => <div className={cx(styles.body, className)}>{children}</div>

Card.List = ({ children, className = '' }) => <div className={cx(styles.list, className)}>{children}</div>

Card.ListElement = ({ className = '', labelKey, value }) => (
  <div className={cx(styles.listElement, className)}>
    <Text typeStyle="bold"><FormattedMessage id={`labels.${labelKey}`} />:</Text>
    <Text size="small">{value}</Text>
  </div>
)

Card.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
  className: PropTypes.string,
}

Card.Header.propTypes = {
  messageId: PropTypes.string.isRequired,
}

Card.Body.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
  className: PropTypes.string,
}

Card.ListElement.propTypes = {
  value: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  className: PropTypes.string,
  labelKey: PropTypes.string.isRequired,
}

Card.List.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
  className: PropTypes.string,
}

export default Card
